function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarningVector = function SvgWarningVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0000"
    },
    d: "m16.242 429.476 216.09-374.281c10.518-18.219 36.814-18.219 47.333 0l216.091 374.281c10.518 18.219-2.63 40.991-23.666 40.991H39.908c-21.036 0-34.185-22.772-23.666-40.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5c525"
    },
    d: "M255.999 322.45c-14.172 0-25.66-11.488-25.66-25.66V172.87c0-14.172 11.488-25.66 25.66-25.66s25.66 11.488 25.66 25.66v123.92c0 14.172-11.488 25.66-25.66 25.66z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#f5c525"
    },
    cx: 256.001,
    cy: 397.558,
    r: 25.034
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5c525"
    },
    d: "M506.597 423.218 290.506 48.937C283.304 36.462 270.404 29.014 256 29.014s-27.304 7.448-34.506 19.922L5.402 423.218c-7.202 12.475-7.202 27.37 0 39.845 7.202 12.475 20.103 19.922 34.507 19.922h432.183c14.405 0 27.305-7.448 34.507-19.922 7.2-12.475 7.2-27.371-.002-39.845zm-21.68 27.327c-1.286 2.227-5.108 7.405-12.826 7.405H39.908c-7.718 0-11.541-5.178-12.826-7.405-1.286-2.227-3.859-8.126 0-14.81l216.09-374.281c3.859-6.683 10.255-7.405 12.826-7.405s8.967.722 12.826 7.405l216.091 374.281c3.86 6.684 1.286 12.583.002 14.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5c525"
    },
    d: "M255.999 134.692c-21.051 0-38.177 17.126-38.177 38.177v123.92c0 21.051 17.126 38.178 38.177 38.178s38.177-17.126 38.177-38.177V172.87c0-21.052-17.126-38.178-38.177-38.178zm13.143 162.098c0 7.247-5.896 13.143-13.143 13.143s-13.143-5.896-13.143-13.143V172.87c0-7.247 5.896-13.143 13.143-13.143s13.143 5.896 13.143 13.143v123.92zM255.999 360.002c-20.706 0-37.552 16.846-37.552 37.552s16.846 37.552 37.552 37.552 37.552-16.846 37.552-37.552c-.001-20.706-16.846-37.552-37.552-37.552zm0 50.069c-6.902 0-12.517-5.615-12.517-12.517 0-6.902 5.615-12.517 12.517-12.517s12.517 5.615 12.517 12.517c0 6.901-5.615 12.517-12.517 12.517z"
  }));
};
export default SvgWarningVector;